import CryptoJS from 'crypto-js';

export const hashPassword = (password: string): string => CryptoJS.SHA256(password).toString();
